import type { RequirementViolationKind } from "@repo/shared";

type IssueText = { needs: string; fix: string };

export const T = {
  en_GB: {
    title: "Some components need a setting this flow doesn't have",
    activation: "The flow can't be activated until each one is fixed or the component is removed.",
    onPage: "on",
    kinds: {
      missing_portfolio_collection: {
        needs: "Needs a portfolio collection",
        fix: "Assign one in the Settings tab.",
      },
      missing_risk_model: { needs: "Needs a risk model", fix: "Assign one in the Settings tab." },
      missing_financial_situation_model: {
        needs: "Needs a financial situation model",
        fix: "Assign one in the Settings tab.",
      },
      collection_missing_asset_allocation: {
        needs: "Needs asset class allocation",
        fix: "Turn it on in the portfolio collection.",
      },
      collection_missing_timeseries: {
        needs: "Needs timeseries",
        fix: "Turn it on in the portfolio collection.",
      },
    },
  },
  nb_NO: {
    title: "Noen komponenter trenger en innstilling denne flyten mangler",
    activation: "Flyten kan ikke aktiveres før hver av dem er rettet eller komponenten er fjernet.",
    onPage: "på",
    kinds: {
      missing_portfolio_collection: {
        needs: "Trenger en porteføljesamling",
        fix: "Velg en i Innstillinger-fanen.",
      },
      missing_risk_model: {
        needs: "Trenger en risikomodell",
        fix: "Velg en i Innstillinger-fanen.",
      },
      missing_financial_situation_model: {
        needs: "Trenger en modell for økonomisk situasjon",
        fix: "Velg en i Innstillinger-fanen.",
      },
      collection_missing_asset_allocation: {
        needs: "Trenger aktivaklassefordeling",
        fix: "Slå det på i porteføljesamlingen.",
      },
      collection_missing_timeseries: {
        needs: "Trenger tidsserier",
        fix: "Slå det på i porteføljesamlingen.",
      },
    },
  },
} as const satisfies Record<
  string,
  {
    title: string;
    activation: string;
    onPage: string;
    kinds: Record<RequirementViolationKind, IssueText>;
  }
>;
